/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * App.tsx — App (services/operator-web-app).
 */

import { BrowserRouter, Routes as RRoutes, Route, Navigate } from 'react-router-dom';
import { appConfig } from '@/config/env';
import { LayoutShell } from '@/layouts/LayoutShell';
import { HomePage } from '@/pages/HomePage';
import { LoginPage } from '@/pages/LoginPage';
import { HistoryPage } from '@/pages/HistoryPage';
import { KnowledgePage } from '@/pages/KnowledgePage';
import { SettingsPage } from '@/pages/SettingsPage';

export function App() {
  return (
    <BrowserRouter basename={appConfig.basePath}>
      <RRoutes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<LayoutShell />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/knowledge" element={<KnowledgePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </RRoutes>
    </BrowserRouter>
  );
}
